
import { useEffect, useState } from "react";

export default function useScrollProgress() {

    const [progress, setProgress] = useState(0);

    useEffect(() => {

        const handleScroll = () => {

            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const fullHeight = document.documentElement.scrollHeight;

            const percentage =
                (scrollTop / (fullHeight - windowHeight)) * 100;

            setProgress(Math.min(percentage, 100));
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };

    }, []);

    return progress;
}